var nl = {
  "Add Quantity Breaks to your product page": "Voeg hoeveelheidskortingen toe aan je productpagina",
  "Add Upsell.com to your ": "Voeg Upsell.com toe aan je ",
  "All time": "Altijd",
  "and select": "en selecteer",
  "button": "knop",
  "Cart drawer page": "Winkelwagenlade-pagina",
  "Cart page": "Winkelwagenpagina",
  "Check status": "Status controleren",
  "Checkout page": "Afrekenpagina",
  "Click": "Klik op",
  "Click on": "Klik op",
  "Click the": "Klik op de",
  "Custom slot": "Aangepaste slot",
  "Custom slots": "Aangepaste slots",
  "Custom Slots": "Aangepaste slots",
  "contact support.": "neem contact op met support.",
  "from the right sidebar": "uit de rechter zijbalk",
  "Go to App Embeds": "Ga naar app-insluitingen",
  "Go to your Cart drawer page": "Ga naar uw Winkelwagenlade-pagina",
  "Go to your Cart page": "Ga naar uw Winkelwagenpagina",
  "Go to your Checkout page": "Ga naar uw Afrekenpagina",
  "Go to your Order status page": "Ga naar uw Bestelstatuspagina",
  "Go to your Post purchase page": "Ga naar uw Post-aankooppagina",
  "Go to your Product page": "Ga naar uw Productpagina",
  "Go to your Thank you page": "Ga naar uw Bedankpagina",
  "items": "items",
  "in the left sidebar": "in de linker zijbalk",
  "Last 12 months": "Laatste 12 maanden",
  "Last 30 days": "Laatste 30 dagen",
  "Last 365 days": "Laatste 365 dagen",
  "Last 7 days": "Laatste 7 dagen",
  "Last 90 days": "Laatste 90 dagen",
  "Last month": "Vorige maand",
  "Last year": "Vorig jaar",
  "Make sure": "Zorg ervoor dat",
  "Need assistance? Contact our support team for help.": "Hulp nodig? Neem contact op met ons supportteam.",
  "Order status page": "Bestelstatuspagina",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Onze app ondergaat momenteel wat magie om uw ervaring te verbeteren.",
  "Post purchase page": "Post-aankooppagina",
  "Product page": "Productpagina",
  "Save": "Opslaan",
  "Scroll to the bottom and select": "Scrol naar beneden en selecteer",
  "Select": "Selecteer",
  "Success. Please continue.": "Succes. Ga verder.",
  "Thank you page": "Bedankpagina",
  "The Upsell.com team.": "Het Upsell.com team.",
  "The Upsell.com widget is not placed on ": "De Upsell.com widget is niet geplaatst op ",
  ". Please follow the steps above or ": ". Volg de bovenstaande stappen of ",
  "Today": "Vandaag",
  "toggle is on": "schakelaar aan staat",
  "Total": "Totaal",
  "under": "onder",
  "We apologize for any inconvenience caused,": "Onze excuses voor het ongemak,",
  "We apologize for any inconvenience caused.": "Onze excuses voor het ongemak.",
  "We'll be done in a few minutes!": "We zijn over een paar minuten klaar!",
  "We're improving our services!": "We verbeteren onze diensten!",
  "Widget already added": "Widget al toegevoegd",
  "Yesterday": "Gisteren",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Je hebt de widget in je webshop ingeschakeld, maar niet opgeslagen in de Upsell-editor",
  "You placed the widget on the ": "U hebt de widget op ",
  ", but you didn't save it in Shopify editor. Please go back to ": " geplaatst, maar u hebt deze niet opgeslagen in de Shopify-editor. Ga terug naar ",
  " and save the changes.": " en sla de wijzigingen op."
};

export { nl as default };
//# sourceMappingURL=nl.json.js.map
